// 2023-11 MH migrating scattered URL paths to this file
//
import LocalUrlMaker from "./LocalUrlMaker";

// Page to compare items by a list of IDs.
// Used by ProductGrid's "compare now" widget.
export function compareItemsPath(compareList) {
  return LocalUrlMaker.prefixedPath(
    "/compare_items?ids=" + compareList.join(','))
}

/**
 * Given a URL (or current URL), extract the path without the prefix.
 *
 * @param url
 * @returns {*}
 */
export function getCleanLocalPath(url) {
  url = toUrl(url || getCurrentUrl());

  return LocalUrlMaker.removePrefix(url.pathname);
}

export function getCurrentUrl() {
  let {location} = globalThis;
  return new URL(location?.href);
}

export function toUrl(url) {
  try {
    if (url?.constructor === url)
      return url;

    return new URL(url);
  } catch (e) {
    console.error(e);
    return null;
  }
}
